import { createCRUDHook } from './createCRUDHook';
import { InventoryDto, InventoryReportDto } from 'utils/models';
import {
  GET_INVENTORY_DATES,
  GET_INVENTORY_REPORTS_BY_DATE,
  TBL_PART_INVENTORY,
  UPDATE_INVENTORY_DATA,
} from './apiEndPoints';
interface InventoryCustomOperations {
  postInventoryData: (param: InventoryDto) => Promise<InventoryDto>;

  fetchInventoryDates: () => Promise<string[]>;

  fetchInventoryReportDataByDate: (
    date: string
  ) => Promise<InventoryReportDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  InventoryDto,
  InventoryDto[],
  InventoryCustomOperations
>({
  entityName: 'Inventory',
  endpoint: TBL_PART_INVENTORY,

  customOperations: (auth) => ({
    postInventoryData: async (param: InventoryDto): Promise<InventoryDto> => {
      try {
        const res = await auth.makeAuthenticatedPost(
          TBL_PART_INVENTORY + UPDATE_INVENTORY_DATA,
          param
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    fetchInventoryDates: async (): Promise<string[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_PART_INVENTORY + GET_INVENTORY_DATES
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    fetchInventoryReportDataByDate: async (
      date: string
    ): Promise<InventoryReportDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_PART_INVENTORY +
            GET_INVENTORY_REPORTS_BY_DATE +
            `?inventoryDate=${date}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const InventoryContext = Context;
export const useInventoryManager = useManager;
export const useInventory = useConsumer;
